<template>
  <d-page-layout :hasSearch="false">
    <template slot="heading">
      <v-breadcrumbs class="pa-0" :items="items"></v-breadcrumbs>
    </template>
    <template slot="actions">
      <v-btn
        color="primary"
        depressed
        class="ml-2"
        @click="addOrEditModal = true"
      >
        <v-icon left> mdi-plus </v-icon>
        <span class="subtitle-2 text-none">{{
          $t("defaults.button.create")
        }}</span>
      </v-btn>
    </template>
    <template slot="content">
      <List @edit="handleEdit"></List>
      <AddOrEditModal
        v-if="addOrEditModal"
        :modal="addOrEditModal"
        :item="selectedItem"
        @closeModal="handleCloseAddOrEditModal"
        @submitModal="handleSubmitAddOrEditModal"
      ></AddOrEditModal>
    </template>
  </d-page-layout>
</template>
<script>
import List from "./List.vue";
import AddOrEditModal from "./AddOrEditModal.vue";

export default {
  components: {
    List,
    AddOrEditModal,
  },
  data: (vm) => ({
    items: [
      {
        text: vm.$t("tokens.page-heading"),
        disabled: true,
      },
    ],
    addOrEditModal: false,
    selectedItem: null,
  }),
  methods: {
    handleEdit(item) {
      this.selectedItem = item;
      this.addOrEditModal = true;
    },
    handleSubmitAddOrEditModal() {
      this.$eventBus.$emit("fetchTokens", this.searchParams);
      this.handleCloseAddOrEditModal();
    },
    handleCloseAddOrEditModal() {
      this.selectedItem = null;
      this.addOrEditModal = false;
    },
  },
  async mounted() {
    this.$eventBus.$emit("fetchTokens", this.searchParams);
  },
};
</script>
